export const TechData = [
    {
        id: 1,
        title: "A Brief Analysis and Purpose of DigiBeat's Digital Stethoscope",
        date:'April 12',
        description:"This article will explore the reasons and features that make our digital stethoscope the best choice for the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/d309afbc-889e-6b3c-6731-5f5646d29df2.png",
        imgLabel:"front facing angle of the digibeat remote stethoscope showcasing the volume control and power button",
        link:"/blog/heropost"
    },
    {
        id: 2,
        title: "Benefits of Integrating Artificial Intelligence into Wireless Stethoscopes",
        date:'April 8',
        description:"Explore the benefits of Artificial Intelligence and how it will aid the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/9c68735c-2761-0179-8204-191283a7b571.jpeg",
        imgLabel:"Nodes showing connection between heart and body using artificial intelligence",
        link:"/blog/aibenefits"
    },
    {
        id: 3,
        title: "1…2…3 and DONE it's that easy to use your DigiBeat Digital Stethoscope at home.",
        date:'April 7',
        description:"Step by step guide on how to use DigiBeat to improve your heart health",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/ffa7588a-bf48-cd04-479a-0e97a20b5b90.png",
        imgLabel:"Image showing DigiBeat's application interface with our augmented reality feature",
        link:"/blog/athomeuse"
    },
    {
        id: 4,
        title: "Silent Heart Attacks",
        date:'April 3',
        description:"What is a silent heart attack and how would a digital stethoscope help?",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/9d149d9c-1ee6-8d00-c489-00955f1565ca.jpg",
        imgLabel:"hand clutching cheast, in pain, experiencing a heart attack",
        link:"/blog/silentheartattacks"
    },
    // {
    //     id: 5,
    //     title: "Why Cardiologist should integrate DigiBeat's Digital Stethoscope into their practices",
    //     date:'April 13',
    //     description:"Learn the technological, patient, and economic benefits of the DigiBeat stethoscope.",
    //     image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/66bc72a6-e7c4-4221-4b9f-53eb626900f8.png",
    //     imgLabel:"Shows DigiBeat's wireless digital stethoscope next to ipad interface",
    //     link:"/blog/feature2"
    // },
    {
        id: 6,
        title: "Why a Digital Stethoscope?",
        date:'April 14',
        description:"Explore the general benefits of digital stethoscopes.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/2dfe0457-0686-fb14-f70b-f939454a0b01.jpg",
        imgLabel:"shows a couple happily interacting with the digibeat device in their own home",
        link:"/blog/whydigital"
    },
]

export const CardiologyData = [
    {
        id: 1,
        title: "A Brief Analysis and Purpose of DigiBeat's Digital Stethoscope",
        date:'April 12',
        description:"This article will explore the reasons and features that make our digital stethoscope the best choice for the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/d309afbc-889e-6b3c-6731-5f5646d29df2.png",
        imgLabel:"front facing angle of the digibeat remote stethoscope showcasing the volume control and power button",
        link:"/blog/heropost"
    },
    {
        id: 2,
        title: "Benefits of Integrating Artificial Intelligence into Wireless Stethoscopes",
        date:'April 8',
        description:"Explore the benefits of Artificial Intelligence and how it will aid the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/9c68735c-2761-0179-8204-191283a7b571.jpeg",
        imgLabel:"Nodes showing connection between heart and body using artificial intelligence",
        link:"/blog/aibenefits"
    },
    {
        id: 3,
        title: "Silent Heart Attacks",
        date:'April 3',
        description:"What is a silent heart attack and how would a digital stethoscope help?",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/9d149d9c-1ee6-8d00-c489-00955f1565ca.jpg",
        imgLabel:"hand clutching cheast, in pain, experiencing a heart attack",
        link:"/blog/silentheartattacks"
    },
    {
        id: 4,
        title: "Why a Digital Stethoscope?",
        date:'April 14',
        description:"Explore the general benefits of digital stethoscopes.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/2dfe0457-0686-fb14-f70b-f939454a0b01.jpg",
        imgLabel:"shows a couple happily interacting with the digibeat device in their own home",
        link:"/blog/whydigital"
    },
    {
        id: 5,
        title: "Frequently Asked Questions About Heart Disease, Answered by Dr.Richards",
        date:'May 18th',
        description:"Learn about heart disease with DigiBeat’s CMO Dr.Richards.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/e63edfae-e12a-3fac-f9b2-2fb44cb63416.jpeg",
        imgLabel:"Shows a heart with earth printed on it in the hands of a physician",
        link:"/blog/healthFAQ"
    },
]

export const RMData = [
    {
        id: 1,
        title: "1…2…3 and DONE it's that easy to use your DigiBeat Digital Stethoscope at home.",
        date:'April 7',
        description:"Step by step guide on how to use DigiBeat to improve your heart health",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/ffa7588a-bf48-cd04-479a-0e97a20b5b90.png",
        imgLabel:"Image showing DigiBeat's application interface with our augmented reality feature",
        link:"/blog/athomeuse"
    },
    {
        id: 2,
        title: "A Brief Analysis and Purpose of DigiBeat's Digital Stethoscope",
        date:'April 12',
        description:"This article will explore the reasons and features that make our digital stethoscope the best choice for the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/d309afbc-889e-6b3c-6731-5f5646d29df2.png",
        imgLabel:"front facing angle of the digibeat remote stethoscope showcasing the volume control and power button",
        link:"/blog/heropost"
    },
    {
        id: 3,
        title: "Benefits of Integrating Artificial Intelligence into Wireless Stethoscopes",
        date:'April 8',
        description:"Explore the benefits of Artificial Intelligence and how it will aid the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/9c68735c-2761-0179-8204-191283a7b571.jpeg",
        imgLabel:"Nodes showing connection between heart and body using artificial intelligence",
        link:"/blog/aibenefits"
    },
]

export const ScienceData = [
    {
        id: 1,
        title: "Benefits of Integrating Artificial Intelligence into Wireless Stethoscopes",
        date:'April 8',
        description:"Explore the benefits of Artificial Intelligence and how it will aid the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/9c68735c-2761-0179-8204-191283a7b571.jpeg",
        imgLabel:"Nodes showing connection between heart and body using artificial intelligence",
        link:"/blog/aibenefits"
    },
    {
        id: 2,
        title: "A Brief Analysis and Purpose of DigiBeat's Digital Stethoscope",
        date:'April 12',
        description:"This article will explore the reasons and features that make our digital stethoscope the best choice for the future of medicine.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/d309afbc-889e-6b3c-6731-5f5646d29df2.png",
        imgLabel:"front facing angle of the digibeat remote stethoscope showcasing the volume control and power button",
        link:"/blog/heropost"
    },
    {
        id: 3,
        title: "Why a Digital Stethoscope?",
        date:'April 14',
        description:"Explore the general benefits of digital stethoscopes.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/2dfe0457-0686-fb14-f70b-f939454a0b01.jpg",
        imgLabel:"shows a couple happily interacting with the digibeat device in their own home",
        link:"/blog/whydigital"
    },
    // {
    //     id: 4,
    //     title: "Why Cardiologist should integrate DigiBeat's Digital Stethoscope into their practices",
    //     date:'April 13',
    //     description:"Learn the technological, patient, and economic benefits of the DigiBeat stethoscope.",
    //     image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/66bc72a6-e7c4-4221-4b9f-53eb626900f8.png",
    //     imgLabel:"Shows DigiBeat's wireless digital stethoscope next to ipad interface",
    //     link:"/blog/feature2"
    // },
    {
        id: 5,
        title: "5 Tips for Eating a Heart Healthy Diet",
        date:'April 10',
        description:"Dietary recommendations for your heart health.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/37bb9916-9ab3-6430-c2b3-7bfc9ab5ea0e.jpg",
        imgLabel:"heart filled with health food",
        link:"/blog/healthyeating"
    },
    {
        id: 6,
        title: "A Quick Glimpse into America's War Against Heart Disease",
        date:'April 13',
        description:"Discover the relevance and your possible risk factors for heart disease in America.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/00976cc8-b764-65af-f69a-d5750be6f847.jpg",
        imgLabel:"Plethora of unhealthy food that can effect your heart and heart disease possibilities",
        link:"/blog/quickglimpse"
    }
]

export const HealthData = [
    {
        id: 1,
        title: "Silent Heart Attacks",
        date:'April 3',
        description:"What is a silent heart attack and how would a digital stethoscope help?",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/9d149d9c-1ee6-8d00-c489-00955f1565ca.jpg",
        imgLabel:"hand clutching cheast, in pain, experiencing a heart attack",
        link:"/blog/silentheartattacks"
    },
    {
        id: 2,
        title: "Frequently Asked Questions About Heart Disease, Answered by Dr.Richards",
        date:'May 18th',
        description:"Learn about heart disease with DigiBeat’s CMO Dr.Richards.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/e63edfae-e12a-3fac-f9b2-2fb44cb63416.jpeg",
        imgLabel:"Shows a heart with earth printed on it in the hands of a physician",
        link:"/blog/healthFAQ"
    },
    {
        id: 3,
        title: "5 Tips for Eating a Heart Healthy Diet",
        date:'April 10',
        description:"Dietary recommendations for your heart health.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/37bb9916-9ab3-6430-c2b3-7bfc9ab5ea0e.jpg",
        imgLabel:"heart filled with health food",
        link:"/blog/healthyeating"
    },
    {
        id: 4,
        title: "10 Tips for Living with Heart/Lung Disease",
        date:'April 11',
        description:"Your options when living with heart disease.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/46d0cb55-52d7-ec96-72ff-c856322b5a2f.jpg",
        imgLabel:"shows a heart healthy smoothie along side runner",
        link:"/blog/10tips"
    },
    {
        id: 5,
        title: "A Quick Glimpse into America's War Against Heart Disease",
        date:'April 13',
        description:"Discover the relevance and your possible risk factors for heart disease in America.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/00976cc8-b764-65af-f69a-d5750be6f847.jpg",
        imgLabel:"Plethora of unhealthy food that can effect your heart and heart disease possibilities",
        link:"/blog/quickglimpse"
    }
]

export const LifeData = [
    {
        id: 1,
        title: "1…2…3 and DONE it's that easy to use your DigiBeat Digital Stethoscope at home.",
        date:'April 7',
        description:"Step by step guide on how to use DigiBeat to improve your heart health",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/ffa7588a-bf48-cd04-479a-0e97a20b5b90.png",
        imgLabel:"Image showing DigiBeat's application interface with our augmented reality feature",
        link:"/blog/athomeuse"
    },
    {
        id: 2,
        title: "5 Tips for Eating a Heart Healthy Diet",
        date:'April 10',
        description:"Dietary recommendations for your heart health.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/37bb9916-9ab3-6430-c2b3-7bfc9ab5ea0e.jpg",
        imgLabel:"heart filled with health food",
        link:"/blog/healthyeating"
    },
    {
        id: 3,
        title: "10 Tips for Living with Heart/Lung Disease",
        date:'April 11',
        description:"Your options when living with heart disease.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/46d0cb55-52d7-ec96-72ff-c856322b5a2f.jpg",
        imgLabel:"shows a heart healthy smoothie along side runner",
        link:"/blog/10tips"
    },
    {
        id: 4,
        title: "A Quick Glimpse into America's War Against Heart Disease",
        date:'April 13',
        description:"Discover the relevance and your possible risk factors for heart disease in America.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/00976cc8-b764-65af-f69a-d5750be6f847.jpg",
        imgLabel:"Plethora of unhealthy food that can effect your heart and heart disease possibilities",
        link:"/blog/quickglimpse"
    },
    {
        id: 5,
        title: "Frequently Asked Questions About Heart Disease, Answered by Dr.Richards",
        date:'May 18th',
        description:"Learn about heart disease with DigiBeat’s CMO Dr.Richards.",
        image:"https://mcusercontent.com/f78a01ed120667028e9e65574/images/e63edfae-e12a-3fac-f9b2-2fb44cb63416.jpeg",
        imgLabel:"Shows a heart with earth printed on it in the hands of a physician",
        link:"/blog/healthFAQ"
    },
]